module.exports = __webpack_public_path__ + "logo-rcbc-sygnet_e3468882e56e49bc85b5eb295f7b64d7.png";